import { BadgeProps } from 'antd-v5';
import { theme } from 'styles';

type HeaderCountBadgeOptions = {
  offset?: BadgeProps['offset'];
};

export const HEADER_ESTIMATE_TEXT_BADGE_OFFSET: BadgeProps['offset'] = [6, 0];

export const getHeaderCountBadgeProps = (count: number, options?: HeaderCountBadgeOptions): BadgeProps => ({
  size: 'small',
  color: theme.color.brand,
  count,
  overflowCount: 999,
  offset: options?.offset,
  styles: {
    indicator: {
      color: theme.color.brand_black,
      fontWeight: 'bold',
      padding: '0 3px',
    },
  },
});
